<header id="header">
  <div class="container">
    <div class="header-row">
      <div class="header-column">
        <div class="logo" *ngIf="loginType=='B2C'">
          <a href="https://www.akbartravels.com/cruises/" title="Book Cruise Tour Packages with Akbar Travels">
            <img src="https://lccintl.ezeeibe.com/cruisextranet/akbar-logo.png" width='162' height='37' alt="Akbar" /></a>
        </div>
        <div class="logo" *ngIf="loginType=='B2B'">
          <a href="https://www.akbartravels.com/cruises/" title="Book Cruise Tour Packages with Akbar Travels">
            <img src="{{imageURL}}" width='162' height='37' alt="Akbar" /></a>
        </div>
        <nav class="navbar navbar-light bg-faded">
          <button class="navbar-toggler hidden-sm-up" type="button"> &#9776;</button>
          <div class="nav-slider">
            <div class="head-left">
              <!-- Menu -->
              <!-- <ul class="subpagemenu">
                <li> <a href="https://www.akbartravels.com/b2cplus/flight" target="_blank"><span
                      class="ak-flight icon"></span>
                    <h3>Flights</h3>
                  </a> </li>
                <li> <a href="https://www.akbartravels.com/b2cplus/hotel" target="_blank"><span
                      class="ak-hotel icon"></span>
                    <h3>Hotels</h3>
                  </a> </li>
                <li> <a href="https://www.akbartravels.com/visa" target="_blank"><span class="ak-visa icon"></span>
                    <h3>Visa</h3>
                  </a> </li>
                <li> <a><span class="ak-holidays icon"></span>
                    <h3>Holidays</h3>
                  </a> </li>
                <li> <a href="https://www.akbarforex.com/" target="_blank"><span class="ak-forex icon"></span>
                    <h3>Forex</h3>
                  </a> </li>
                <li> <a href="https://www.akbartravels.com/bus-ticket-booking" target="_blank"><span
                      class="ak-bus icon"></span>
                    <h3>Bus</h3>
                  </a> </li>
                <li class="active"> <a href="https://www.akbartravels.com/jalesh-cruise/" target="_blank"><span
                      class="ak-cruise icon"></span>
                    <h3>Cruise</h3>
                  </a> </li>
                <li> <a class="dropdown-trigger" data-target="moremenu-list"> <span class="ak-more icon"></span>
                    <h3>More</h3>
                  </a> </li>
              </ul> -->
              <!-- Menu End-->
              <div class="header-column justify-content-end">
                <div class="primary-menu  navbar-expand-lg" *ngIf="loginType=='B2C'">
                  <ul class="navbar-nav">
                    <!-- <li>
                      <div class="form-group">
                        <div class="select-country" data-input-name="country2" data-selected-country="IN"> </div>
                      </div>
                    </li>
                    <li>
                      <div id="options" data-input-name="country2" data-selected-country="IN"> </div>
                    </li> -->
                    <li class="login-signup">
                      <a href="tel:+912268818888 " class="btn-phone"> <span class="ak-phone-receiver"></span> +91 22 6881 8888 
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- <div class="primary-menu  navbar-expand-lg" *ngIf="loginType=='B2B'">
                  <ul class="navbar-nav">
                    <div class="my_account">
                      <div class="sub_header_link3" *ngIf="agent.AgencyName" id="helloAcc"><span id="spnMyAcc"
                          style="display: inline;">
                          Hello {{agent.AgencyName.split(' ')[0]}} {{balancestr}}</span>
                        <i class="down_arw"></i>
                        <div class="dropdown-menu3">
                          <div class="booking_pnl">
                            <a class="sb_link_2" *ngFor="let item of menuItems" href="{{item.Link}}">{{item.Parent}}</a>
                            <a class="sb_link_2" data-toggle="modal" (click)="logoutagent()" href="#">Logout</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div> -->

                <!-------------------------------
              B2D HEADER RIGHT SIDE START
              ------------------------------->

                <div class="b2b-menu" *ngIf="loginType=='B2B'">

                  <button class="btn btn-primary balance-btn" type="button"
                    *ngIf="usertype!='OO' && usertype!='OOU'">Balance: ₹ {{balancestr}} </button>

                  <div class="dropdown">
                    <button (click)="showDropDown=!showDropDown" class="btn btn-primary dropdown-toggle afterlogin"
                      type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      <i class="ak-user icon"></i>{{username}}
                    </button>
                    <div class="dropdown-menu dropdown-menu-right" [ngClass]="showDropDown?'show':''"
                      aria-labelledby="dropdownMenuButton" *ngIf="usertype !='OO' && usertype !='OOU'">
                      <!-- <a class="dropdown-item" href="#"><i class="ak-mist icon"></i> Your Activity </a> -->
                      <a class="dropdown-item" href="reports"><i class="ak-businesscard icon"></i> My Bookings </a>
                      <!-- <a class="dropdown-item" href="https://agents.akbartravelsonline.com/MyAccount/MyProfile"><i
                          class="ak-user icon"></i> My Account </a> -->
                      <!-- <a class="dropdown-item" href="#"><i class="ak-rupee icon"></i> Your Markup </a> -->
                      <a class="dropdown-item logoutbtn" href="https://agents.akbartravelsonline.com/MyAccount/Login"
                        (click)="logout()"><i class="ak-logout icon"></i> Logout</a>
                    </div>
                    <div class="dropdown-menu dropdown-menu-right" [ngClass]="showDropDown?'show':''"
                      aria-labelledby="dropdownMenuButton" *ngIf="usertype =='OO' || usertype =='OOU'">
                      <!-- <a class="dropdown-item" href="#"><i class="ak-mist icon"></i> Your Activity </a> -->
                      <a class="dropdown-item" href="reports"><i class="ak-businesscard icon"></i> Reports </a>
                      <a class="dropdown-item" href="dashboard"><i
                          class="ak-user icon"></i> Dashboard </a>
                      <a class="dropdown-item" href="{{link}}"><i class="ak-rupee icon"></i> Control Panel </a>
                      <a class="dropdown-item logoutbtn" href="https://agents.akbartravelsonline.com/MyAccount/Login"
                        (click)="logout()"><i class="ak-logout icon"></i> Logout</a>
                    </div>
                  </div>


                </div>

                <!-------------------------------
            B2D HEADER RIGHT SIDE START
            ------------------------------->

              </div>
            </div>
          </div>
          <div class="nav-mask"></div>
        </nav>
      </div>
    </div>
  </div>
</header>